import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "icon icon-edit",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M3.91,8.68v2.73c0,.38,.31,.68,.68,.68h2.73c.18,0,.35-.07,.48-.2l7.5-7.5c.27-.27,.27-.7,0-.96L12.57,.7c-.13-.13-.3-.2-.48-.2s-.35,.07-.48,.2l-7.5,7.5c-.13,.13-.2,.3-.2,.48Zm1.36,.28L12.09,2.15l1.76,1.76-6.82,6.82h-1.76v-1.76Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M14.82,7.32c-.38,0-.68,.31-.68,.68v6.14H1.86V1.86h6.14c.38,0,.68-.31,.68-.68s-.31-.68-.68-.68H1.18c-.38,0-.68,.31-.68,.68V14.82c0,.38,.31,.68,.68,.68H14.82c.38,0,.68-.31,.68-.68v-6.82c0-.38-.31-.68-.68-.68Z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}